"use client";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { ResponsiveStyleValue } from "@mui/system";
import Link from "~/components/Link";

type Props = {
  size?: ResponsiveStyleValue<number | string>;
  title?: string;
  description?: string;
  href?: string;
};

export default function AddSongTile({
  size = 160,
  title = "Creează",
  description = "o melodie personalizată",
  href = "/comanda",
}: Props) {
  return (
    <Box sx={{ display: "flex" }}>
      <Link href={href} effect="none" sx={{ textDecoration: "none", display: "block" }}>
        <Paper
          elevation={2}
          sx={{
            position: "relative",
            cursor: "pointer",
            borderRadius: 3,
            overflow: "hidden",
            width: size,
            flexShrink: 0,
            transition: "all 0.2s ease",
            display: "flex",
            flexDirection: "column",
            // hover overlay similar to SongTile
            "&:hover .artworkOverlay": {
              opacity: 1,
              pointerEvents: "auto",
              "& .addButton:hover": {
                transform: "scale(1.2)",
                bgcolor: "rgba(0,0,0,0.6)",
              },
            },
            "&:hover": {
              transform: "scale(1.03)",
              elevation: 4,
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: size,
              height: size,
              aspectRatio: "1 / 1",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: "action.hover",
            }}
          >
            {/* base icon (subtle) */}
            <AddIcon sx={{ fontSize: 48, color: "primary.main", opacity: 0.9 }} />

            {/* Hover overlay (reveals on parent hover) */}
            <Box
              className="artworkOverlay"
              sx={{
                position: "absolute",
                inset: 0,
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "rgba(0,0,0,0.15)",
                opacity: 0,
                transition: "opacity 200ms",
                pointerEvents: "none",
              }}
            >
            </Box>
          </Box>

          <Box sx={{ p: 1.5 }}>
            <Typography variant="subtitle2" noWrap sx={{
              fontWeight: 700
            }}>
              {title}
            </Typography>
            {description && (
              <Typography
                variant="caption"
                sx={{
                  color: "text.secondary",
                  display: "-webkit-box",
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden"
                }}>
                {description}
              </Typography>
            )}
          </Box>
        </Paper>
      </Link>
    </Box>
  );
}
